import { render, staticRenderFns } from "./SoilSensorsList.vue?vue&type=template&id=856b7950&scoped=true&lang=pug"
import script from "./SoilSensorsList.vue?vue&type=script&lang=js"
export * from "./SoilSensorsList.vue?vue&type=script&lang=js"
import style0 from "./SoilSensorsList.vue?vue&type=style&index=0&id=856b7950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b7950",
  null
  
)

export default component.exports